import { FC, useEffect, useState } from 'react';
import { SCUIContent } from '../../../atomic/organisms';
import { useTranslation } from 'react-i18next';
import { CreateReturnActiveStep1, CreateReturnActiveStep2, CreateReturnActiveStep3 } from '../CreateReturn/components';
import { SCUIBreadCrumb, SCUIStepper, SCUITextFieldWithButton } from '../../../atomic/molecules';
import { SCUIButton, SCUILoadingLinear } from '../../../atomic/atoms';
import { Grid, Typography, Stack, Box } from '@mui/material';
import TimeHelper from '../../../utils/time';
import { StoreQuery, CacheQuery, OrderQuery } from '../../../services/query';
import Swal from 'sweetalert2';
import { useLocation } from 'react-router-dom';
import Helper from '../../../utils/helper';
import { ReturnCommand } from '../../../services/command';
import { useHistory } from 'react-router-dom';
import { CR } from './createReturn.classes';

export const CreateReturn: FC<any> = () => {
    const { t } = useTranslation();
    const query = new URLSearchParams(useLocation().search);
    const oderNumberFromUrl = query.get('orderNumber');
    const shippingListNoFromUrl = query.get('shippingListNo');
    const orderNumberFromUrlBar = oderNumberFromUrl && oderNumberFromUrl;
    const shippingListNoFromUrlBar = shippingListNoFromUrl && shippingListNoFromUrl;
    const [selectedValue, setSelectedValue] = useState(0);
    const [selectedShippingName, setSelectedShippingName] = useState('');
    const [loading, setLoading] = useState(false);
    const [selectedShipping, setSelectedShipping] = useState<any>();
    const [simulateReturnRequest, setSimulateReturnRequest] = useState<any>();
    const [selectedShippingNo, setSelectedShippingNo] = useState('');
    const [selectedProductCount, setSelectedProductCount] = useState(0);
    const [isSellerStore, setIsSellerStore] = useState(false);
    const [customerId, setCustomerID] = useState(0);
    const [orderId, setOrderId] = useState(0);
    const [orderDate, setOrderDate] = useState(0);
    const [orderNumber, setOrderNumber] = useState(0);
    const [activeStep, setActiveStep] = useState<number>(1);
    const [simulateReturnResponse, setSimulateReturnResponse] = useState<any>();
    const [combinedList, setCombinedList] = useState<any>([]);
    const [combinedListFirst, setCombinedListFirst] = useState<any>([]);
    const [showCMIY, setShowCMIY] = useState(false); //Çağrı Merkezi İstisna Yönetimi
    const [checkedCMIY, setCheckedCMIY] = useState(false);
    const [isCmMpRejectReturn, setIsCmMpRejectReturn] = useState(false);
    const [sellerName, setSellerName] = useState<any>();
    const [selectedSellerID, setSelectedSellerID] = useState<any>();
    const lostCargoStatus = 18;
    useEffect(() => {
        if (!isSellerStore) return;
        CacheQuery.GetUSerClaims().then((res: any) => {
                setIsCmMpRejectReturn(res.includes('backoffice_cmMpRejectReturn'));
            });
    }, [isSellerStore]);

    useEffect(() => {
        if (!isCmMpRejectReturn) return;
        OrderQuery.GetSellerNameList().then((res: any) => {
                setSellerName(res.data);
            });
    }, [isCmMpRejectReturn]);

    const filtrele = (): void => {
        if (selectedShippingNo.trim().length === 0 && combinedListFirst) {
            setCombinedList(combinedListFirst);
            setSelectedValue(0);
        } else {
            let filteredShipping = combinedListFirst.filter(
                (element: any) => element.shippingListNo === selectedShippingNo
            );
            if (combinedListFirst && filteredShipping.length > 0) {
                setCombinedList(filteredShipping);
                if (filteredShipping[0].isReturnable) {
                    setSelectedValue(filteredShipping[0].shippingListId);
                }
            } else {
                Swal.fire({
                    icon: 'error',
                    title: t('general.checkShipmentInfo'),
                    showConfirmButton: false,
                    timer: 1000,
                });
                setCombinedList(combinedListFirst);
                setSelectedValue(0);
            }
        }
    };

    const goBackFunc: any = useHistory();

    const _onClickStepNext = (): void => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };
    const _onClickStep = (clickedStep: number): void => {
        if (clickedStep === 1) {
            // Restore full shipping list so filter from previous selection does not hide other options
            setCombinedList(combinedListFirst);
            setSelectedShippingNo('');
        }
        if (clickedStep === 2) {
            setCheckedCMIY(false);
            if (!selectedShipping) Swal.fire(t('general.selectShipment'), '', 'error');
        }
        if (clickedStep === 3 && !simulateReturnResponse) {
            Swal.fire(t('general.selectProduct'), '', 'error');
        } else setActiveStep(clickedStep);
    };

    useEffect(() => {
        if (orderNumberFromUrlBar || shippingListNoFromUrlBar) {
            listele();
        }
    }, [orderNumberFromUrlBar, shippingListNoFromUrlBar]);

    const handleCheckedCMIYChange = (newCheckedCMIY: any) => {
        setCheckedCMIY(newCheckedCMIY);
    };

    const listele = async () => {
        let array: any[] = [];
        setLoading(true);
        let params: any = {};
        if (orderNumberFromUrlBar) params.orderNo = orderNumberFromUrlBar;
        if (shippingListNoFromUrlBar) params.ShippingListNo = shippingListNoFromUrlBar;
        params.Type = 'Return';
        StoreQuery.GetStoreSaleOrderByOrderNoV2(params)
            .then(async (res: any) => {
                if (!res)
                    Swal.fire({
                        icon: 'error',
                        title: t('general.notFound'),
                        showConfirmButton: true,
                    });

                if (res.data.shippingListForBackofficeModels.length === 0)
                    Swal.fire({
                        icon: 'error',
                        title: t('general.shipmentInfoNotFound'),
                        showConfirmButton: true,
                    });
                if (
                    res?.data?.hasLostPackage &&
                    res?.data?.shippingListForBackofficeModels?.length == 1 &&
                    res?.data?.shippingListForBackofficeModels[0]?.statusId == lostCargoStatus
                ) {
                    window.location.href = `/lost-cargo-return-page?shippingListNo=${res?.data?.shippingListForBackofficeModels[0]?.shippingListNo}`;
                    return;
                }
                if (res.data.orderId && res.data.customerId !== 0) {
                    setOrderId(res.data.orderId);
                    setCustomerID(res.data.customerId);
                    setOrderNumber(res.data.orderNumber);
                    setOrderDate(res.data.orderDate);
                    for (const item of res.data.shippingListForBackofficeModels) {
                        let paramsCheckReturnAvailibility: any = {};
                        paramsCheckReturnAvailibility.orderId = res.data.orderId;
                        paramsCheckReturnAvailibility.customerId = res.data.customerId;
                        paramsCheckReturnAvailibility.StoreCode = Helper.getStoreCode();
                        paramsCheckReturnAvailibility.isMarketPlaceReturn = item.isSellerStore;
                        paramsCheckReturnAvailibility.isLostPackage = item.isLostPackage;
                        // setIsSellerStore(item.isSellerStore);
                        if (item.isSellerStore) {
                            paramsCheckReturnAvailibility.shippingListId = item.shippingListId;
                        }
                        const response = await ReturnCommand.PostCheckReturnAvailability(paramsCheckReturnAvailibility);
                        if (response.canStoreUserCreateRefund === false) {
                            setLoading(false);
                            Swal.fire({
                                icon: 'warning',
                                title: t('return.cannotCreateReturn'),
                                showConfirmButton: true,
                                timer: 5000,
                            }).then(() => {
                                goBackFunc.push('/returnList');
                            });
                            return;
                        }

                        const foundShipping = response.checkReturnAvailablityList.find(
                            (x: any) => x.shippingListId === item.shippingListId
                        );
                        // isLostPackage bilgisini ekle
                        array.push({
                            ...foundShipping,
                            isLostPackage: item.isLostPackage || false,
                        });
                        setShowCMIY(response.showCmiy);
                    }
                }
            })

            .finally(() => {
                setCombinedList(array);
                setCombinedListFirst(array);
                setLoading(false);
            });
    };

    useEffect(() => {
        if (combinedListFirst && shippingListNoFromUrlBar) {
            setSelectedShippingNo(shippingListNoFromUrlBar);
            filtrele();
        } //sevkiyat bazında gösteriyoruz
    }, [combinedListFirst]);

    return (
        <SCUIContent className={CR.page}>
            <Grid className={CR.layout} container direction="row" spacing={2} sx={{ paddingLeft: 1 }}>
                <Stack className={CR.headerRow} direction="row" spacing={2}>
                    <Grid
                        size={{
                            sm: 12,
                            md: 12,
                            lg: 12,
                            xl: 4
                        }}>
                        <p className={['headtxt', CR.orderNumberText].filter(Boolean).join(' ')} style={{ paddingTop: '0.4rem' }}>
                            {orderNumber ? orderNumber : orderNumberFromUrlBar}
                        </p>
                    </Grid>
                    <Grid
                        className={CR.breadcrumbSection}
                        size={{
                            sm: 12,
                            md: 12,
                            lg: 12,
                            xl: 8
                        }}>
                        <SCUIBreadCrumb title={t('dashboard.returnRequests')} componentLink={'/returnList'} />
                    </Grid>
                </Stack>

                {combinedListFirst && combinedListFirst.length > 0 ? (
                    <>
                        {selectedShippingName && (
                            <Grid
                                className={CR.shippingInfoRow}
                                size={{
                                    xl: 12,
                                    lg: 12,
                                    md: 12,
                                    xs: 12
                                }}>
                                <p>
                                    <b>
                                        {t('general.shippingNo')} : {selectedShippingName}
                                    </b>
                                </p>
                            </Grid>
                        )}

                        {
                            <Grid
                                className={CR.orderDateRow}
                                size={{
                                    sm: 12,
                                    md: 12,
                                    lg: 12,
                                    xl: 12
                                }}>
                                <Typography>
                                    {' '}
                                    <strong>
                                        {t('general.orderDate')} : {TimeHelper.formatDateHour(orderDate) || '-'}
                                    </strong>{' '}
                                </Typography>
                            </Grid>
                        }

                        <Grid
                            className={CR.stepperSection}
                            sx={{ paddingBottom: 3 }}
                            size={{
                                sm: 12,
                                md: 12,
                                lg: 12,
                                xl: 12
                            }}>
                            <SCUIStepper
                                stepList={[
                                    { id: 1, name: t('return.shipmentSelection') },
                                    { id: 2, name: t('return.productSelection') },
                                    { id: 3, name: t('return.refundPaymentInformation') },
                                ]}
                                activeStep={activeStep}
                                onClick={_onClickStep}
                            ></SCUIStepper>
                        </Grid>

                        {combinedListFirst && combinedListFirst.length > 1 && activeStep === 1 && (
                            <Grid
                                className={CR.shippingFilterRow}
                                size={{
                                    sm: 12,
                                    md: 12,
                                    lg: 12,
                                    xl: 12
                                }}>
                                <SCUITextFieldWithButton
                                    width={300}
                                    placeholder={t('general.shippingNo')}
                                    paperClassName={CR.shippingFilterPaper}
                                    inputClassName={CR.shippingFilterInput}
                                    iconButtonClassName={CR.shippingFilterIconButton}
                                    value={selectedShippingNo}
                                    onChange={(event: any) => {
                                        setSelectedShippingNo(event.target.value);
                                    }}
                                    onClick={() => filtrele()}
                                    onKeyPress={(e: any) => {
                                        if (e.key === 'Enter') {
                                            e.preventDefault();
                                            filtrele();
                                        }
                                    }}
                                />
                            </Grid>
                        )}

                        {combinedList.map((shipping: any) => (
                            <div key={shipping?.shippingListId ?? shipping?.shippingListNo ?? shipping?.id ?? JSON.stringify(shipping)} className={CR.step1Section}>
                                {activeStep === 1 && orderId && customerId && (
                                    <CreateReturnActiveStep1
                                        setIsSellerStore={setIsSellerStore}
                                        setActiveStep={setActiveStep}
                                        orderId={orderId}
                                        customerId={customerId}
                                        shipping={shipping}
                                        setSelectedValue={setSelectedValue}
                                        selectedValue={selectedValue}
                                        setSelectedShipping={setSelectedShipping}
                                        shippingCount={combinedList.length}
                                        setSelectedShippingName={setSelectedShippingName}
                                    />
                                )}
                            </div>
                        ))}
                        {activeStep === 2 && selectedShipping && (
                            <Grid
                                className={CR.step2Section}
                                size={{
                                    xs: 12,
                                    md: 12,
                                    lg: 12,
                                    xl: 12
                                }}>
                                <CreateReturnActiveStep2
                                    selectedShipping={selectedShipping}
                                    orderID={orderId}
                                    customerID={customerId}
                                    onClickStepNext={_onClickStepNext}
                                    setSimulateReturnResponse={setSimulateReturnResponse}
                                    setSimulateReturnRequest={setSimulateReturnRequest}
                                    selectedProductCount={selectedProductCount}
                                    setSelectedProductCount={setSelectedProductCount}
                                    setSelectedSellerID={setSelectedSellerID}
                                    sellerName={sellerName}
                                    showCMIY={showCMIY}
                                    isSellerStore={isSellerStore}
                                    cmiyCheckboxChanged={(checkedCMIY) => handleCheckedCMIYChange(checkedCMIY)}
                                />
                            </Grid>
                        )}
                        {activeStep === 3 && simulateReturnResponse && (
                            <Grid
                                className={CR.step3Section}
                                size={{
                                    xs: 12,
                                    md: 12,
                                    lg: 12,
                                    xl: 12
                                }}>
                                <CreateReturnActiveStep3
                                    selectedSellerID={selectedSellerID}
                                    isCmMpRejectReturn={isCmMpRejectReturn}
                                    isSellerStore={isSellerStore}
                                    customerID={customerId}
                                    simulateReturn={simulateReturnResponse}
                                    createReturnRequest={simulateReturnRequest}
                                    selectedProductCount={selectedProductCount}
                                    showCMIY={showCMIY}
                                    isCheckedCMIY={checkedCMIY}
                                />
                            </Grid>
                        )}

                        <Grid
                            className={CR.footerActionsRow}
                            justifyContent="flex-end"
                            sx={{ paddingRight: '5rem' }}
                            size={{
                                xs: 12,
                                md: 12,
                                lg: 12,
                                xl: 12
                            }}>
                            <Box display="flex" justifyContent="flex-end">
                                {selectedValue === 0 ? (
                                    <Typography className={CR.noSelectionText}>
                                        {' '}
                                        <strong>{t('general.noSelectionMade')}</strong>
                                    </Typography>
                                ) : (
                                    activeStep === 1 && (
                                        <SCUIButton
                                            className={CR.continueButton}
                                            text={t('general.continue')}
                                            type="primary"
                                            sizeType="fixed"
                                            onClick={() => _onClickStepNext()}
                                            size={'m'}
                                        />
                                    )
                                )}
                            </Box>
                        </Grid>
                    </>
                ) : (
                    <>
                        <Grid
                            className={CR.emptyGoBackRow}
                            justifyContent="flex-end"
                            size={{
                                xs: 12,
                                md: 12,
                                lg: 12,
                                xl: 12
                            }}>
                            <p
                                className={[CR.goBackLink, 'linktxt'].join(' ')}
                                onClick={() => goBackFunc?.goBack()}
                            >
                                {t('general.goBack')}
                            </p>
                        </Grid>
                        <div className={CR.loadingSection}>
                            <SCUILoadingLinear display={loading} />
                        </div>
                    </>
                )}
            </Grid>
        </SCUIContent>
    );
};
